export const ReserveDepositStatus = {
  NotReceived: 1,
  Received: 2,
  WaitToRefund: 3,
  Refunded: 4,
  NoRefund: 5,
};
